import React from "react";
import DashboardLayout from "../../layout/DashboardLayout.js";
// import ProfileDetails from "./ProfileDetails.js";
import UserLists from "./UserLists.js";
import { Box } from "@mui/material";
// import { getUserById } from "../../services/userService";


function Lists() {
  // const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <DashboardLayout pageName="Profile">
      {/* <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' },  gap: 2}}> */}
        <UserLists />
      {/* </Box> */}
    </DashboardLayout>
  );
}

export default Lists;